import { useActivityTracking } from '~/composables/useActivityTracking';

// Feeds the admin Activity page: logs which portal tools signed-in agents open.
export default defineNuxtPlugin(() => {
  const router = useRouter();
  const route = useRoute();
  const { trackPath } = useActivityTracking();

  onNuxtReady(() => trackPath(route.path));

  router.afterEach((to, from) => {
    if (to.path !== from.path) trackPath(to.path);
  });
});
